const GA4_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID || 'G-J9JXH620D9';
const CLARITY_ID = import.meta.env.VITE_CLARITY_PROJECT_ID || 'vq2n74ws7l';

let initialized = false;
let lastTrackedPath = null;

const initGa4 = () => {
  if (!GA4_ID) return;
  if (window.gtag) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA4_ID, { send_page_view: false });
};

const initClarity = () => {
  if (!CLARITY_ID || window.clarity) return;
  (function(c, l, a, r, i, t, y) {
    c[a] = c[a] || function() {
      (c[a].q = c[a].q || []).push(arguments);
    };
    t = l.createElement(r);
    t.async = 1;
    t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', CLARITY_ID);
};

export const initAnalytics = () => {
  if (initialized) return;
  initialized = true;
  initGa4();
  initClarity();
};

export const trackPageView = (path) => {
  if (!path || lastTrackedPath === path) return;
  lastTrackedPath = path;

  if (window.gtag && GA4_ID) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title
    });
  }
};

export const trackEvent = (eventName, properties = {}) => {
  if (!eventName) return;

  if (window.gtag && GA4_ID) {
    window.gtag('event', eventName, properties);
  }
};
